module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/v2/logo_teams.6b4e1ac088270d6bc887d2ae9bcbb04c.svg";